import React from 'react'
import StatusBadge from '../StatusBadge'
import { ConstantService } from '../../services/ConstantService'
import { ColumnFilterDefinition, ColumnFilterOption } from './ColumnFilterTypes'

/**
 * Kolon filtresindeki seçim listeleri için ortak yükleyiciler. Her liste ekranı
 * kendi `columnFilterDefinitions` nesnesinde bunları kullanır:
 *
 *   bankName: { type: 'select', loadOptions: () => loadConstants('BANK') },
 *   isCustomActive: YES_NO_FILTER,
 */

/** Bir servis çağrısının sonucunu seçenek listesine çevirir. Hata mesajı filtre panelinde gösterilir. */
export const loadList = async (request: Promise<any>, valueName: string, labelOf: (x: any) => string): Promise<ColumnFilterOption[]> => {
    const response = await request

    if (!response.isSuccess)
        throw response.message

    return (response.data ?? []).map((x: any) => ({ value: String(x[valueName]), label: labelOf(x) }))
}

/** Sabit (Constant) listesi, ör. loadConstants('BANK'). Etiket Value alanı. */
export const loadConstants = (code: string, parentId?: string) =>
    loadList(ConstantService.getConstantList(code, parentId), 'constantId', x => x.value)

/** Döviz gibi kısa kodu AdditionalValue1'de duran sabitler (listede "TRY" görünür). */
export const loadConstantsByCode = (code: string, parentId?: string) =>
    loadList(ConstantService.getConstantList(code, parentId), 'constantId', x => x.additionalValue1 ?? x.value)

export const yesNoOptions = (): Promise<ColumnFilterOption[]> => Promise.resolve([
    { value: '1', label: 'Evet' },
    { value: '0', label: 'Hayır' },
])

/**
 * Evet/Hayır kolonları (Aktif, B2C, Gelir, Gider…). Backend: FilterMap.Bool.
 * "(Boş)" seçeneği yok; boş değer "Hayır" sayılır.
 */
/** Yurtiçi kargo "Elle Güncellendi": Evet / Otomatik / Hayır (backend: YurticiCargoManager isPoManual filtresi). */
export const PO_GUNCELLEME_FILTER: ColumnFilterDefinition = {
    type: 'select',
    allowEmpty: false,
    loadOptions: () => Promise.resolve([
        { value: '1', label: 'Evet' },
        { value: '2', label: 'Otomatik' },
        { value: '0', label: 'Hayır' },
    ]),
    renderOption: (label) => <StatusBadge text={label} />,
}

export const YES_NO_FILTER: ColumnFilterDefinition = {
    type: 'select',
    allowEmpty: false,
    loadOptions: yesNoOptions,
    renderOption: (label) => <StatusBadge text={label} />,
}
